import ThemeSwitch from './ThemeSwitch';

export default ThemeSwitch;
export type { ThemeSwitchHandle } from './ThemeSwitch';
